
import { axios } from "../axios.instance";

export type SendFeedbackRequest = {
  type: "complaint" | "question";
  subject: string;
  body: string;
};

export type SendFeedbackResponse = unknown;

export const sendFeedback = async (body: SendFeedbackRequest): Promise<SendFeedbackResponse> => {
  const { data } = await axios.post(`/feedbacks/send`, body);

  return data;
};
